import useStateWithInterface from 'src/viewLayer/components/hooks/useStateWithInterface'

const INITIAL_STATE = {
  data: null,
  errors: [],
  inProgress: false,
}

const stateInterface = {
  onAttempt: () => ({
    errors: INITIAL_STATE.errors,
    inProgress: true,
  }),
  onFailure: (errors) => ({
    ...INITIAL_STATE,
    errors,
  }),
  onSuccess: (data) => ({
    ...INITIAL_STATE,
    data,
  }),
}

export default () => useStateWithInterface(INITIAL_STATE, stateInterface)
